module.exports = __webpack_public_path__ + "img/app_icon_3.e30c410c.png";